/** @format */

// import { filter } from "lodash";
import { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// material
import {
  Button,
  Card,
  CircularProgress,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import Iconify from "../../components/Iconify";
import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from '../../reusables/table/TableMenuDropdown';
// import TableMenuItem from "../../reusables/table/TableMenuItem";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
//
import User from "../../dao/User";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false, sortable: false },
  { id: "first_name", label: "Name", alignRight: false, sortable: true },
  { id: "email", label: "Email", alignRight: false, sortable: true },
  { id: "role", label: "Role", alignRight: false, sortable: false },
];

// ----------------------------------------------------------------------

export default function UserList() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("created_at");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const getUsers = async () => {
    try {
      let result = await User.getAll();
      let profiles = result.map((el) => ({ ...el.profile, role: el.role }));
      setUsers(profiles);
      setIsDataFetched(true);
    } catch (e) {
      // nothing
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    count = page * rowsPerPage + 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // const emptyRows =
  //   page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;
  const filteredUsers = applySortFilter(
    users,
    getComparator(order, orderBy),
    filterName,
    "first_name"
  );
  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Users List">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Users
          </Typography>
          <Button
            variant="contained"
            component={RouterLink}
            to="/user/create"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            New User
          </Button>
        </Stack>

        <Card>
          <SearchToolbar
            filterName={filterName}
            onFilterName={handleFilterByName}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table style={{ backgroundColor: "white", color: "white" }}>
                <SortableTableHeader
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { first_name, last_name, email, role } = row;
                      return (
                        <TableRow
                          hover
                          key={row.user_id}
                          tabIndex={-1}
                          role="checkbox"
                        >
                          <TableCell align="left">{count++}</TableCell>
                          <TableCell align="left">{`${first_name} ${last_name}`}</TableCell>
                          <TableCell align="left">{email}</TableCell>
                          <TableCell align="left">{role}</TableCell>
                          <TableCell align="right">
                            <Button
                              onClick={() => {
                                navigate(`/user/${row.user_id}/details`);
                              }}
                              variant={"outlined"}
                              style={{ textDecoration: "none" }}
                            >
                              Detail
                            </Button>
                            {/*<TableMenuItem icon="mdi:account-details" label="Details" to={`/user/${row.user_id}/details`} />*/}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {/*{emptyRows > 0 && (*/}
                  {/*  <TableRow style={{height: 69 * emptyRows}}>*/}
                  {/*    <TableCell colSpan={6}/>*/}
                  {/*  </TableRow>*/}
                  {/*)}*/}
                </TableBody>
                {(isUserNotFound || !isDataFetched) && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {!isDataFetched ? (
                          <CircularProgress />
                        ) : (
                          <SearchNotFound searchQuery={filterName} />
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 20, 50, 100]}
            component="div"
            count={users.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
